import type { OrgsList } from "../../types/defaultTypes";
import { apiClient } from "../clientApi";
import type { AxiosResponse } from "axios";

export interface SurveyDetailUser {
  id: number;
  orgId: number;
  courseName: string;
  created_at: "2025-09-29T18:20:00.000Z";
  updated_at: "2025-09-29T18:20:00.000Z";
  surveyJson: [
    {
      id: string;
      text: string;
      type: string;
      order: number;
      options: { id: string; answer: string; order: number }[];
      settings: {
        maxChars: number;
        minChars: number;
      };
    }
  ];
}

export const getUserSurvey = async (id: number | string) => {
  const { data } = await apiClient.get<SurveyDetailUser, AxiosResponse<SurveyDetailUser>>(`/user-surveys/${id}`);

  return data as SurveyDetailUser;
};
